// This function is used to simplify and centralize rendering of all navigation labels in the application (NavigationLabel => NL for short in JSX)
import { Typography } from "@mui/material";

export default function NL(text: string): JSX.Element {
    return (<Typography variant='button'>{text}</Typography>)
} 
